import type { MouseEvent, FocusEvent } from 'react';
import { LoadingSpinner } from '@simplywallst/ui-core';
import { ResetIcon, SearchSpinner, ColorTheme } from './styled';
import { Status } from '@/hooks/useSearch';

interface Props {
  searchStatus?: Status;
  searchQuery: string;
  active?: boolean;
  styleType?: ColorTheme;
  onReset: (e: MouseEvent) => void;
  onFocus?: (e: FocusEvent) => void;
}

const SearchFieldPostfix = ({
  searchStatus = Status.IDLE,
  searchQuery,
  styleType,
  active = true,
  onReset,
  onFocus,
}: Props) => {
  return searchStatus === Status.SEARCHING && active ? (
    <SearchSpinner data-cy-id="search-field-searching">
      <LoadingSpinner styleType="light" top="50%" left="4px" />
    </SearchSpinner>
  ) : searchQuery.length > 0 && searchStatus === Status.IDLE ? (
    <ResetIcon
      tabIndex={0}
      onFocus={(e: FocusEvent) => {
        if (onFocus) onFocus(e);
      }}
      onClick={onReset}
      color={styleType}
      data-cy-id="search-field-reset"
    />
  ) : null;
};

export default SearchFieldPostfix;
